import { useSiteConfig } from "@/context/SiteConfigContext";

export default function Manifesto() {
  const { config } = useSiteConfig();
  const m = config?.landing?.manifesto || {};
  const items = m.items || [];

  return (
    <section
      id="manifiesto"
      data-testid="manifesto"
      className="py-24 md:py-40 border-y hairline relative"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink-mid">
            {m.eyebrow || "◊ El manifiesto"}
          </p>
          <p data-testid="manifesto-intro" className="mt-4 text-sm text-ink/70 max-w-xs">
            {m.intro || "Cuatro principios. Ninguna concesión."}
          </p>
        </div>

        <div className="col-span-12 md:col-span-9">
          <div className="space-y-10 md:space-y-14">
            {items.map((p, i) => (
              <div
                key={`${p.n}-${i}`}
                data-testid={`manifesto-item-${p.n}`}
                className="grid grid-cols-12 gap-6 pb-10 md:pb-14 border-b hairline last:border-b-0"
              >
                <span className="col-span-2 md:col-span-1 font-mono text-xs text-coral pt-2">
                  {p.n}
                </span>
                <h3 className="col-span-10 md:col-span-6 font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight">
                  {p.t}
                </h3>
                <p className="col-span-12 md:col-span-5 text-base md:text-lg text-ink/75 leading-relaxed md:pt-3">
                  {p.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
